let setIntervalId;
let messageRotationIntervalId;

const LOADER_MESSAGE_INTERVAL = 3000;

const getLoaderTextElement = () => document.getElementById('loader-animation-text');

const removeLoaderTextElement = () => {
  const textElement = getLoaderTextElement();
  if (textElement) {
    textElement.remove();
  }
};

export const hideLoader = () => {
  clearInterval(setIntervalId);
  clearInterval(messageRotationIntervalId);
  
  // Clean up loader message element
  removeLoaderTextElement();
  
  const ele = document.querySelectorAll('#loader');
  if (ele && ele.length > 0) {
    ele.forEach((item) => {
      const loader = item;
      loader.style.display = 'none';
    });
  }
};

const displayLoaderMessage = (message) => {
  if (!message) {
    removeLoaderTextElement();
    return;
  }
  
  const messages = Array.isArray(message) ? message : [message];
  
  if (messages && messages.length > 0) {
    const loaderElement = document.getElementById('loader');
    let textElement = getLoaderTextElement();
    
    if (loaderElement && !textElement) {
      textElement = document.createElement('div');
      textElement.setAttribute('id', 'loader-animation-text');
      textElement.setAttribute('role', 'alert');
      textElement.setAttribute('aria-live', 'assertive');
      textElement.style.cssText = 'position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); margin-top: -3rem; text-align: center; font-weight: bold; z-index: 4; font-family: "VerizonNHGDS", "Arial", "Helvetica Neue", Helvetica, Arial, sans-serif;';
      loaderElement.appendChild(textElement);
    }
    
    if (!textElement) {
      return;
    }
    
    let index = 0;
    textElement.innerHTML = messages[index];
    index += 1;
    
    if (messageRotationIntervalId) {
      clearInterval(messageRotationIntervalId);
    }
    
    messageRotationIntervalId = setInterval(() => {
      const currentTextElement = getLoaderTextElement();
      if (!currentTextElement) {
        clearInterval(messageRotationIntervalId);
        return;
      }
      
      if (index < messages.length) {
        currentTextElement.innerHTML = messages[index];
        index += 1;
      } else {
        clearInterval(messageRotationIntervalId);
      }
    }, LOADER_MESSAGE_INTERVAL);
  }
};

export const showLoader = (message) => {
  try {
    const ele = document.getElementById('loader');
    clearInterval(setIntervalId);
    clearInterval(messageRotationIntervalId);
    if (ele) {
      if (ele.style.display === 'block') {
        const loaderContent = document.querySelector('.content_update_loading');
        if (loaderContent) {
          loaderContent.ariaLabel = 'content is loading';
        }
        // Performance improve and avoids calling focusTrap.activate() twice;
        return;
      }
      ele.style.display = 'block';
    } else {
      const injectLoader = document.createElement('div');
      injectLoader.setAttribute('id', 'loader');
      injectLoader.setAttribute('aria-label', 'loader overlay');
      injectLoader.setAttribute('class', 'loaderOverlay');
      injectLoader.setAttribute('role', 'alert');
      injectLoader.setAttribute('aria-live', 'assertive');
      injectLoader.innerHTML = '<div class="loader"></div><div class="content_update_loading"></div>';
      document.body.appendChild(injectLoader);
      const loaderContent = document.querySelector('.content_update_loading');
      if (loaderContent) {
        loaderContent.ariaLabel = 'content is loading';
      }
    }
    // Display message if provided
    displayLoaderMessage(message);
    setIntervalId = setInterval(() => {
      const loaderContent = document.querySelector('.content_update_loading');
      if (loaderContent) {
        loaderContent.innerHTML = '';
        setTimeout(() => {
          loaderContent.ariaLabel = 'still loading';
        }, 1000);
      } else {
        clearInterval(setIntervalId);
      }
    }, 60000);
  } catch (e) {
    console.log(e);
  }
};

export const hideHTMLLoader = () => {
  clearInterval(setIntervalId);
  clearInterval(messageRotationIntervalId);
  
  // Clean up loader message element
  removeLoaderTextElement();
  
  const ele = document.getElementById('loader');
  if (ele) {
    ele.style.display = 'none';
  }
};
